// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════
   NAVBAR – Design moderne GS7S
═══════════════════════════════════════ */

.navbar {
  background-color: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  padding: 0 !important;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

/* ── Logo ── */
.navbar .logo {
  width: 62px;
  height: 62px;
  border-radius: 6px;
  object-fit: contain;
  margin-left: 0.5rem;
  transition: opacity 0.2s;
}
.navbar .logo:hover {
  opacity: 0.8;
}

/* ── Container alignement vertical ── */
.navbar > .container-fluid {
  align-items: center;
  min-height: 70px;
}

/* ── Liens navigation ── */
.navbar .link,
.navbar .link .nav-link,
.navbar .navbar-nav .nav-link {
  color: #1f2937 !important;
  font-size: 13.5px;
  font-weight: 500 !important;
  letter-spacing: 0.01em;
  padding: 0.55rem 0.7rem !important;
  position: relative;
  transition: color 0.2s;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.navbar .navbar-nav {
  align-items: center;
  gap: 0.1rem;
}

/* Soulignement rouge animé au hover */
.navbar .link::after,
.navbar .navbar-nav .nav-link::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) scaleX(0);
  width: 60%;
  height: 2px;
  background-color: #dc2626;
  border-radius: 2px;
  transition: transform 0.25s ease;
}

.navbar .link:hover,
.navbar .navbar-nav .nav-link:hover {
  color: #dc2626 !important;
}

.navbar .link:hover::after,
.navbar .navbar-nav .nav-link:hover::after {
  transform: translateX(-50%) scaleX(1);
}

/* ── Lien "Nous contacter" mis en avant ── */
.navbar .contact-link {
  background-color: #dc2626 !important;

  border-radius: 6px;
  margin-left: 0.4rem;
  padding: 0.4rem 0.9rem !important;
  font-size: 13px;
  font-weight: 700 !important;
}
.navbar .contact-link:hover {
  background-color: #b91c1c !important;
  color: #ffffff !important;
}
.navbar .contact-link::after {
  display: none;
}

/* ── Dropdown menu ── */
.navbar .dropdown-menu {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.4rem 0;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  min-width: 260px;
  margin-top: 0 !important;
}

.navbar .dropdown-item {
  color: #374151;
  font-size: 13px;
  font-weight: 600;
  padding: 0.55rem 1.2rem;
  transition: background-color 0.15s, color 0.15s;
  border-left: 2px solid transparent;
}
.navbar .dropdown-item:hover {
  background-color: #fef2f2;
  color: #dc2626;
  border-left-color: #dc2626;
}

/* ── Icône chevron dropdown ── */
.navbar .dropdown-toggle::after {
  border-color: #6b7280 transparent transparent transparent;
}

/* ── Sélecteur de langue ── */
.traduction {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-right: 0.75rem;
}

.lang-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  background: none;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 4px 8px;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
}
.lang-btn:hover {
  border-color: #dc2626;
  background-color: #fef2f2;
}
.lang-btn img {
  width: 24px;
  height: 24px;
  border-radius: 3px;
  object-fit: cover;
}
.lang-btn span {
  color: #6b7280;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
}
.lang-btn:hover span {
  color: #dc2626;
}

/* ── Hamburger mobile ── */
.navbar-toggler {
  border-color: #d1d5db !important;
}

/* ── Menu mobile ouvert ── */
@media (max-width: 991px) {
  .navbar .navbar-collapse {
    background-color: #ffffff;
    padding: 0.75rem 1rem 1rem;
    border-top: 1px solid #f3f4f6;
  }
  .navbar .navbar-nav {
    align-items: flex-start;
    gap: 0;
  }
  .navbar .link,
  .navbar .navbar-nav .nav-link {
    padding: 0.65rem 0.25rem !important;
    border-bottom: 1px solid #f3f4f6;
    width: 100%;
  }
  .navbar .link::after,
  .navbar .navbar-nav .nav-link::after {
    display: none;
  }
  .navbar .contact-link {
    display: inline-block;
    margin: 0.5rem 0 0 0;
    width: -moz-fit-content;
    width: fit-content;
  }
  .navbar .dropdown-menu {
    box-shadow: none;
    border: none;
    background-color: #f9fafb;
    padding-left: 0.75rem;
  }
  .traduction {
    margin: 0.75rem 0 0 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/navbar.css"],"names":[],"mappings":"AAAA;;yCAEyC;;AAEzC;EACE,yBAAyB;EACzB,gCAAgC;EAChC,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,0CAA0C;AAC5C;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;;;EAGE,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,sCAAsC;AACtC;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,qCAAqC;EACrC,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA,6CAA6C;AAC7C;EACE,oCAAoC;;EAEpC,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,+CAA+C;EAC/C,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,yDAAyD;AAC3D;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oDAAoD;AACtD;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,uBAAuB;IACvB,MAAM;EACR;EACA;;IAEE,mCAAmC;IACnC,gCAAgC;IAChC,WAAW;EACb;EACA;;IAEE,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,oBAAoB;IACpB,uBAAkB;IAAlB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["/* ═══════════════════════════════════════\r\n   NAVBAR – Design moderne GS7S\r\n═══════════════════════════════════════ */\r\n\r\n.navbar {\r\n  background-color: #ffffff;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  padding: 0 !important;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1000;\r\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n/* ── Logo ── */\r\n.navbar .logo {\r\n  width: 62px;\r\n  height: 62px;\r\n  border-radius: 6px;\r\n  object-fit: contain;\r\n  margin-left: 0.5rem;\r\n  transition: opacity 0.2s;\r\n}\r\n.navbar .logo:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n/* ── Container alignement vertical ── */\r\n.navbar > .container-fluid {\r\n  align-items: center;\r\n  min-height: 70px;\r\n}\r\n\r\n/* ── Liens navigation ── */\r\n.navbar .link,\r\n.navbar .link .nav-link,\r\n.navbar .navbar-nav .nav-link {\r\n  color: #1f2937 !important;\r\n  font-size: 13.5px;\r\n  font-weight: 500 !important;\r\n  letter-spacing: 0.01em;\r\n  padding: 0.55rem 0.7rem !important;\r\n  position: relative;\r\n  transition: color 0.2s;\r\n  white-space: nowrap;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.navbar .navbar-nav {\r\n  align-items: center;\r\n  gap: 0.1rem;\r\n}\r\n\r\n/* Soulignement rouge animé au hover */\r\n.navbar .link::after,\r\n.navbar .navbar-nav .nav-link::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 50%;\r\n  transform: translateX(-50%) scaleX(0);\r\n  width: 60%;\r\n  height: 2px;\r\n  background-color: #dc2626;\r\n  border-radius: 2px;\r\n  transition: transform 0.25s ease;\r\n}\r\n\r\n.navbar .link:hover,\r\n.navbar .navbar-nav .nav-link:hover {\r\n  color: #dc2626 !important;\r\n}\r\n\r\n.navbar .link:hover::after,\r\n.navbar .navbar-nav .nav-link:hover::after {\r\n  transform: translateX(-50%) scaleX(1);\r\n}\r\n\r\n/* ── Lien \"Nous contacter\" mis en avant ── */\r\n.navbar .contact-link {\r\n  background-color: #dc2626 !important;\r\n\r\n  border-radius: 6px;\r\n  margin-left: 0.4rem;\r\n  padding: 0.4rem 0.9rem !important;\r\n  font-size: 13px;\r\n  font-weight: 700 !important;\r\n}\r\n.navbar .contact-link:hover {\r\n  background-color: #b91c1c !important;\r\n  color: #ffffff !important;\r\n}\r\n.navbar .contact-link::after {\r\n  display: none;\r\n}\r\n\r\n/* ── Dropdown menu ── */\r\n.navbar .dropdown-menu {\r\n  background-color: #ffffff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 0.4rem 0;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\r\n  min-width: 260px;\r\n  margin-top: 0 !important;\r\n}\r\n\r\n.navbar .dropdown-item {\r\n  color: #374151;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  padding: 0.55rem 1.2rem;\r\n  transition: background-color 0.15s, color 0.15s;\r\n  border-left: 2px solid transparent;\r\n}\r\n.navbar .dropdown-item:hover {\r\n  background-color: #fef2f2;\r\n  color: #dc2626;\r\n  border-left-color: #dc2626;\r\n}\r\n\r\n/* ── Icône chevron dropdown ── */\r\n.navbar .dropdown-toggle::after {\r\n  border-color: #6b7280 transparent transparent transparent;\r\n}\r\n\r\n/* ── Sélecteur de langue ── */\r\n.traduction {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  margin-right: 0.75rem;\r\n}\r\n\r\n.lang-btn {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 2px;\r\n  background: none;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  padding: 4px 8px;\r\n  cursor: pointer;\r\n  transition: border-color 0.2s, background-color 0.2s;\r\n}\r\n.lang-btn:hover {\r\n  border-color: #dc2626;\r\n  background-color: #fef2f2;\r\n}\r\n.lang-btn img {\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 3px;\r\n  object-fit: cover;\r\n}\r\n.lang-btn span {\r\n  color: #6b7280;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.05em;\r\n}\r\n.lang-btn:hover span {\r\n  color: #dc2626;\r\n}\r\n\r\n/* ── Hamburger mobile ── */\r\n.navbar-toggler {\r\n  border-color: #d1d5db !important;\r\n}\r\n\r\n/* ── Menu mobile ouvert ── */\r\n@media (max-width: 991px) {\r\n  .navbar .navbar-collapse {\r\n    background-color: #ffffff;\r\n    padding: 0.75rem 1rem 1rem;\r\n    border-top: 1px solid #f3f4f6;\r\n  }\r\n  .navbar .navbar-nav {\r\n    align-items: flex-start;\r\n    gap: 0;\r\n  }\r\n  .navbar .link,\r\n  .navbar .navbar-nav .nav-link {\r\n    padding: 0.65rem 0.25rem !important;\r\n    border-bottom: 1px solid #f3f4f6;\r\n    width: 100%;\r\n  }\r\n  .navbar .link::after,\r\n  .navbar .navbar-nav .nav-link::after {\r\n    display: none;\r\n  }\r\n  .navbar .contact-link {\r\n    display: inline-block;\r\n    margin: 0.5rem 0 0 0;\r\n    width: fit-content;\r\n  }\r\n  .navbar .dropdown-menu {\r\n    box-shadow: none;\r\n    border: none;\r\n    background-color: #f9fafb;\r\n    padding-left: 0.75rem;\r\n  }\r\n  .traduction {\r\n    margin: 0.75rem 0 0 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
